import { render, staticRenderFns } from "./TranProgramActivityReminderCreateDetail.vue?vue&type=template&id=7c8324f6"
import script from "./TranProgramActivityReminderCreateDetail.vue?vue&type=script&lang=js"
export * from "./TranProgramActivityReminderCreateDetail.vue?vue&type=script&lang=js"
import style0 from "./TranProgramActivityReminderCreateDetail.vue?vue&type=style&index=0&id=7c8324f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports